<script context="module">
  const colors = [
    'rgba(243, 61, 186, 0.4)','rgba(151, 227, 60, 0.4)','rgba(44, 24, 253, 0.4)','rgba(40, 56, 36, 0.4)','rgba(184, 205, 135, 0.4)',
    'rgba(13, 251, 185, 0.4)','rgba(255, 25, 71, 0.4)','rgba(125, 164, 86, 0.4)','rgba(177, 26, 255, 0.4)','rgba(242, 73, 14, 0.4)',
    'rgba(164, 71, 123, 0.4)','rgba(255, 255, 0, 0.4)','rgba(7, 174, 255, 0.4)','rgba(255, 172, 189, 0.4)','rgba(0, 0, 0, 0.4)',
    'rgba(255, 200, 0, 0.4)','rgba(0, 52, 255, 0.4)','rgba(149, 165, 166, 0.5)'
  ]
</script>

<script>
  import Part from './Part.svelte'
  import { getLinesForBlock } from './logic'

  export let articles
  export let page
  export let offsetx
  export let offsety
  export let scale
  export let state
  export let moving
  export let error

  let open = null
  let lines

  function move(index, order, value) {
    //const elm = input.slice(from, 1)[0]
    //input.splice(to, 0, elm)
    //input.splice(to, 0, input.splice(from, 1)[0])
    console.log('a',index, order, value, state, articles[index].groups)
    if (value > articles[index].groups.length) value = articles[index].groups.length
    else if (value < 1) value = 1

    const indexf = value ? index : +state.index
    const orderf = value ? value-1 : 1+state.order
    //debugger
    const elm = articles[index].groups.splice(order, 1)[0]
    articles[indexf].groups.splice(orderf, 0, elm)
    articles = articles // modified
    elm.isIgnored = false
    console.log('move', value, indexf, orderf, index, order, elm, state, articles)

    if (state?.restart) {
    }
    else if (state?.reorder) {
      state.order = state.reorder
      state.reorder += 1
    } else if (state?.add) {  // add
      //state = null
      state.order = orderf
    }
    //console.log('b',state,articles[index].groups)
    //if (value) open.order = state?.order
    //return value - 1
  }

  async function split(index, order) {
    const article = articles[index]
    const obj = article.groups[order]
    const block = {page: obj.page, hpos: obj.hpos, vpos: obj.vpos, width: obj.width, height: obj.height}
    console.log('split',block)

    lines = await getLinesForBlock(article.issue, block)
    console.log('getLinesForBlock', lines)
    if (!lines.msg) {
      state = {index, order, split: true, block, issueId: article.issue, articleId: article.id};
    } else {
      error = lines.msg
      lines = null
    }
  }

  $: if (!state) lines = null
</script>

<!-- {JSON.stringify(open)} {JSON.stringify(lines)} -->
<div>
 {#if !moving && !lines}
  {#each articles as article, index}
    {#each article.groups as group, order}
      {#if +group.page === +page && (!state?.reorder || state.index === index)}
        <!--slot {group} color={colors[index]} /-->
        <div class="group"
            style:background-color={state?.reorder <= order ? '' : group.isIgnored ? '' : colors[index%colors.length]}
            style:top="{group.vpos*scale+offsety}px"
            style:left="{group.hpos*scale+offsetx}px"
            style:width="{group.width*scale}px"
            style:height="{group.height*scale}px"
        >
          <Part {order} bind:type={group.type} bind:open max={article.groups.length}
              bind:ignored={group.isIgnored} bind:state {index} {move} {split}
          >
            {#if !group.isIgnored && group.width*scale > 100} 
              {'('+(index+1)+')'}
            {/if}
            {#if state?.reorder}
              {order >= state.reorder ? '?' : order+1}
            {:else}
              {group.isIgnored ? 0 : order+1}
            {/if}
          </Part>
        </div>
      {/if}
    {/each}
  {/each}
 {/if}

 {#if lines && state?.split}
   {#each lines as group, order}
    <div class="group"
      style:background-color={state.seq == order ? 'rgba(151, 227, 60, 0.4)' : 'rgba(243, 61, 186, 0.4)'}
      style:top="{group.vpos*scale+offsety}px"
      style:left="{group.hpos*scale+offsetx}px"
      style:width="{group.width*scale}px"
      style:height="{group.height*scale}px"
    >
      <span on:mousedown|stopPropagation={() => {state.line=group; state.seq = order; console.log('spliting',order,group)}}>
        {order+1}
      </span>
    </div>
   {/each}
 {/if}
</div>

<style>
  .group:nth-child(2n) span {
    float: left;
  }

  .group span {
    background-color: green;
  }

</style>